// extracted by mini-css-extract-plugin
export default {"wrapper":"TIORepaymentStrategy_wrapper__5BwP5","stack":"TIORepaymentStrategy_stack__lgbuP","space":"TIORepaymentStrategy_space__H8CwQ"};